import { Component, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { ConstantService } from "app/Shared/Services/constant-service";
import { UrlsService } from "app/Shared/Services/urls.service";
import { ConfirmationService } from "primeng/api";
import { AuthServiceService } from "../auth-service.service";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ToastModule } from "primeng/toast";

@Component({
	selector: 'app-login-form',
	templateUrl: './login-form.component.html',
	imports: [RouterModule, ReactiveFormsModule, CommonModule, FormsModule, ConfirmDialogModule, ToastModule],
	styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
	loginimgArray: any = ["/images/login.jpg"];
	loginimg: any = ""
	currentYear: number;

	constructor(
		private router: Router,
		public authenticationService: AuthServiceService,
		public urlsService: UrlsService,
		public constantService: ConstantService,
		public confirmationService: ConfirmationService) {
		this.currentYear = new Date().getFullYear();
		this.router.navigate(['/login/sign-in']);
	}

	ngOnInit() {
		this.loginimg = this.loginimgArray[0];
		this.LoadBckground();
		this.authenticationService.logout();
	}

	LoadBckground() {
		let count = 0;
		this.loginimg = this.loginimgArray[count];
	}
}
